_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
formatNumber = require 'app/scripts/lib/format/number'
{ getKey, Key } = require '@trello/keybindings'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('directory')

{ PowerUpTestIds } = require '@trello/webdriverio-tests'
{ categories } = require('app/scripts/data/directory')

class DirectorySidebarPlaceholder extends React.Component
  displayName: 'Directory Sidebar Placeholder'

  render: t.renderable ->
    t.div ->
      t.div '.directory-search', ->
        t.div '.directory-navigation-option.placeholder'
      t.ul ->
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li '.directory-categories', ->
          t.div '.directory-categories-heading.placeholder', ->
          t.ul '.directory-navigation-categories-list', ->
            _.forEach categories, (categoryKey) ->
              t.li ->
                t.div '.directory-navigation-option.placeholder'

class DirectorySidebar extends React.Component
  displayName: 'Directory Sidebar'

  constructor: (props) ->
    super(props)

    @directorySearchInput = null

  componentDidMount: ->
    @focusDirectorySearchInput()

  focusDirectorySearchInput: =>
    @directorySearchInput?.focus()

  render: t.renderable ->
    setDirectorySearchInput = (el) => @directorySearchInput = el

    { enabledCount, showCustomCategory, clearSearch, section, category, idPlugin,
      onCategoryClick, onHomeClick, onEnabledClick, onCustomClick, onSearchKeyUp } = @props
    t.div ->
      t.div '.directory-search', ->
        t.input '.js-directory-search' , {
          type: 'text',
          placeholder: t.l('search'),
          onKeyUp: onSearchKeyUp,
          ref: setDirectorySearchInput
        }
        t.a '.icon-sm.icon-close.dark-hover.hide.js-directory-search-clear', { href: '#', onClick: clearSearch }
      t.div '.directory-navigation-section', ->
        t.ul ->
          t.li { onClick: onHomeClick }, ->
            t.a '.directory-navigation-option', { href: '#', class: t.classify({
              'active': !section && !category && !idPlugin
              }) }, ->
                t.formatText 'featured'
          t.li { onClick: onEnabledClick }, ->
            t.a '.directory-navigation-option.enable-option', {
              href: '#',
              class: t.classify({
                'active': section == 'enabled'
              }),
              'data-test-id': PowerUpTestIds.EnabledPowerUpsLink
            }, ->
              t.formatText 'enabled'
              t.span '.directory-navigation-power-up-count', ->
                t.text enabledCount
          if showCustomCategory
            t.li { onClick: onCustomClick }, ->
              t.a '.directory-navigation-option', { href: '#', class: t.classify({ 'active': section == 'custom' }) }, ->
                t.formatText 'custom'

      t.div '.directory-navigation-section', ->
        t.ul ->
          _.forEach categories, (categoryKey) ->
            t.li { onClick: -> onCategoryClick(categoryKey) }, ->
              t.a '.directory-navigation-option.category-link', {
                class: t.classify({ 'active': category == categoryKey })
                href: '#'
              }, ->
                t.format categoryKey

module.exports = class DirectorySidebarView extends BaseDirectoryView
  className: 'directory-sidebar js-directory-sidebar'

  initialize: ({ @directoryView }) ->
    super

    @onSearchKeyUp = _.debounce @onSearchKeyUp, 100

    @listenTo @model, 'change:powerUps': @render
    @listenTo @model.boardPluginList, 'add remove reset': @render
    @subscribe pluginsChangedSignal(@model), => @render()

  updateSearch: (search) ->
    @directoryView.updateSearch(search)

    clearButton = @$('.js-directory-search-clear')
    if search?.length
      clearButton.removeClass('hide')
    else
      clearButton.addClass('hide')

    @directoryView.headerView.render()

  onSearchKeyUp: (e) ->
    search = e.target.value
    key = getKey(e)

    if key == Key.Escape
      search = null
      @emptySearchField()

    # Close the responsive sidebar on Enter
    if key == Key.Enter && @$el.hasClass('active')
      @directoryView.toggleNavigationMenu()

    # Make sure the value has changed.
    if search != @directoryView.search
      @updateSearch(search)

  emptySearchField: ->
    @$('.js-directory-search').val('')

  clearSearch: ->
    @emptySearchField()
    @updateSearch(null)

  navigateTo: (section, category) ->
    @directoryView.navigate({ section, category })

    if @$el.hasClass('active')
      @directoryView.toggleNavigationMenu()

  renderContent: ->
    { section, category, idPlugin, history, isLoading } = @directoryView

    if (isLoading)
      return React.createElement DirectorySidebarPlaceholder

    enabledCount = ''

    totalEnabled = @model.get('powerUps').length + @model.powerUpsCount()

    if totalEnabled > 0
      enabledCount = formatNumber(totalEnabled)

    React.createElement DirectorySidebar, {
      enabledCount
      section
      idPlugin
      category: category || (idPlugin? && _.last(history)?.category)
      showCustomCategory: !_.isEmpty @directoryView.getCustomPlugins()
      clearSearch: => @clearSearch()
      onSearchKeyUp: (e) =>
        e.persist()
        @onSearchKeyUp(e)
      onCategoryClick: (categoryKey) => @navigateTo('category', categoryKey)
      onHomeClick: => @navigateTo()
      onEnabledClick: => @navigateTo('enabled')
      onCustomClick: => @navigateTo('custom')
    }
